var _rect, _path, _circle;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLabels(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 22,
    height: 22,
    rx: 11,
    fill: "none",
    strokeLinecap: "round",
    strokeDasharray: "2 3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4519 6.44654C12.6583 6.24012 12.9446 6.13421 13.2357 6.1566L16.5187 6.40913C17.0105 6.44696 17.4012 6.83771 17.4391 7.32949L17.6916 10.6125C17.714 10.9036 17.6081 11.1899 17.4016 11.3963L10.6558 18.1421C10.2653 18.5327 9.63211 18.5327 9.24158 18.1421L5.70605 14.6066C5.31553 14.2161 5.31553 13.5829 5.70605 13.1924L12.4519 6.44654Z",
    fill: "none"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 9,
    r: 1,
    stroke: "none"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLabels);
export default __webpack_public_path__ + "static/media/labels.f72a712d.svg";
export { ForwardRef as ReactComponent };